import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const BigUserIcon = (props: SvgProps) => (
  <Svg
    
    width={20}
    height={18}
    fill="none"
    {...props}
  >
    <Path
      fill="#000"
      d="M10.002 8.18c-1.097 0-2.034-.389-2.811-1.166-.777-.777-1.166-1.714-1.166-2.81 0-1.098.389-2.035 1.166-2.812C7.968.616 8.905.227 10 .227c1.098 0 2.035.389 2.811 1.165.777.777 1.166 1.714 1.166 2.811s-.389 2.034-1.166 2.811c-.776.777-1.713 1.165-2.81 1.165ZM.668 17.721V15.61c0-.55.157-1.06.471-1.53.314-.469.746-.836 1.295-1.1a19.969 19.969 0 0 1 3.804-1.363 15.863 15.863 0 0 1 3.764-.461c1.248 0 2.503.153 3.766.46 1.263.306 2.531.76 3.804 1.363.548.264.98.631 1.293 1.101.313.47.47.98.47 1.53v2.113H.668Zm1.256-1.255h16.155v-.855a1.42 1.42 0 0 0-.291-.859 2.473 2.473 0 0 0-.811-.684 17.19 17.19 0 0 0-3.434-1.234 15.026 15.026 0 0 0-7.092 0A16.846 16.846 0 0 0 3.04 14.07c-.355.192-.63.42-.824.687-.194.266-.291.55-.291.853v.858Zm8.078-9.543a2.62 2.62 0 0 0 1.921-.8 2.62 2.62 0 0 0 .8-1.92 2.62 2.62 0 0 0-.8-1.922 2.62 2.62 0 0 0-1.921-.8 2.62 2.62 0 0 0-1.922.8 2.62 2.62 0 0 0-.799 1.921c0 .748.266 1.389.8 1.922a2.62 2.62 0 0 0 1.92.799Z"
    />
  </Svg>
)
export default BigUserIcon
